import { render, staticRenderFns } from "./spareGoodsList.vue?vue&type=template&id=2bd2c5a6&scoped=true"
import script from "./spareGoodsList.vue?vue&type=script&lang=js"
export * from "./spareGoodsList.vue?vue&type=script&lang=js"
import style0 from "./spareGoodsList.vue?vue&type=style&index=0&id=2bd2c5a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd2c5a6",
  null
  
)

export default component.exports